"use client";

import * as React from "react";
import { DateRange } from "react-day-picker";
import { formatDate } from "../../../lib/hooks/utils";
import { cn } from "../../../lib/utils/cn";
import { Button } from "./button";
import { Calendar } from "./calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";

interface DatePickerWithRangeProps extends React.HTMLAttributes<HTMLDivElement> {
  setDate: (date: DateRange | undefined) => void;
  date: DateRange | undefined;
}

export function DatePickerWithRange({ className, setDate, date }: DatePickerWithRangeProps) {
  return (
    <div className={cn("grid gap-2", className)}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            id="date"
            variant={"outline"}
            className={cn("justify-start text-left font-normal", !date && "text-muted-foreground")}
          >
            {date?.from ? (
              date.to ? (
                <>
                  {formatDate(date.from.toUTCString())} - {formatDate(date.to.toUTCString())}
                </>
              ) : (
                formatDate(date.from.toUTCString())
              )
            ) : (
              <span>Wähle ein Zeitraum</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            initialFocus
            mode="range"
            defaultMonth={new Date()}
            selected={date}
            onSelect={(date) => {
              const from = date?.from ? new Date(date.from) : undefined;
              const to = date?.to ? new Date(date.to) : undefined;

              // Calculate timezone offset in hours to get start of day in UTC
              /*const timezoneOffsetHours = -new Date().getTimezoneOffset() / 60;

              from?.setHours(timezoneOffsetHours, 0, 0, 0);
              to?.setHours(timezoneOffsetHours, 0, 0, 0);*/
              setDate({
                from: from,
                to: to,
              });
            }}
            numberOfMonths={2}
            disabled={{ after: new Date() }}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
